import { IRoblexEnviroment } from '../interfaces/roblex-enviroment.interface';

export const RoblexEnviromentDev: IRoblexEnviroment = {
    identitiesUrl: 'https://identitiesdev.roblex.pe',
    operationsUrl: 'https://operationsdev.roblex.pe',
    promotionsUrl: 'https://promotionsdev.roblex.pe',
    verificationsUrl: 'https://verificationsdev.roblex.pe',
    searchPromotionUrl: 'https://roblexdev.pe/#/promociones',
    notificationUrl: 'https://alertsdev.pe/#/promociones',
    reviewsUrl: 'https://reviewsdev.roblex.pe',
};